import { useEffect } from "react"
import Axios from "axios"
import { useImmerReducer } from "use-immer"
import { TOP_RATED_MOVIES } from "../helpers/config"

export const useTopMovieFetch = () => {
  const initialState = {
    movies: [
      {
        id: "",
        overview: "",
        release_date: "",
        adult: "",
        backdrop_path: "",
        vote_count: "",
        genre_ids: [],
        vote_average: "",
        original_language: "",
        original_title: "",
        poster_path: "",
        title: "",
        video: "",
        popularity: "",
        media_type: "",
      },
    ],
    isMovieFetching: "",
    isTvFetching: "",
    page: 1,
    loadMoreRequestCount: 0,
  }

  function ourReducer(draft, action) {
    switch (action.type) {
      case "loadMovies":
        draft.movies = action.data
        return
      case "loadMoreMovies":
        draft.movies = draft.movies.concat(action.data)
        return
      case "fetchingRequestStart":
        draft.isMovieFetching = action.value
        return
      case "loadMore":
        draft.page = draft.page + 1
        draft.loadMoreRequestCount = draft.loadMoreRequestCount + 1
        return
      default:
        console.log("our")
    }
  }

  const [state, topDispatch] = useImmerReducer(ourReducer, initialState)

  const fetchMovie = async (ourRuqest) => {
    try {
      let response = await Axios.get(`${TOP_RATED_MOVIES}${state.page}`, { cancelToken: ourRuqest.token })
      if (state.page > 1) {
        topDispatch({ type: "loadMoreMovies", data: response.data.results })
      } else {
        topDispatch({ type: "loadMovies", data: response.data.results })
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    let ourRequest = Axios.CancelToken.source()
    fetchMovie(ourRequest)
    return () => {
      ourRequest.cancel()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.page])

  let tops = state.movies

  return [tops, topDispatch]
}
